<script>
/* globals window */
import withBreakpoint from './breakpoints/with-breakpoint';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
    name: 'viewAvailableHomes',
    mixins: [withBreakpoint],
    data: function(){
        return {
            dropdownOpen: false,
            selected: 1,
            activeKey: null,
        }
    },

    methods: {
        isActive(i) {
            return this.activeKey === i;
        },
        toggleActive(i) {
            this.activeKey = this.isActive(i) ? null : i;
        }
        
    }
};

</script>



// WEBPACK FOOTER //
// resources/components/apps/view-available-homes.vue